import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import userManager from '../../utils/userManager';
import Button from './button';
import i18n from 'i18next';
import icons from './../../icons.svg';
import { supportedLanguages } from './utils';

const User = ({ t, user }) => {
  const [userProfile, setUserProfile] = useState(null);
  const [pageLanguage, setPageLanguage] = useState('en');
  const [openLanguageSelection, setOpenLanguageSelection] = useState(false);

  useEffect(() => {
    const { language } = i18n;
    setPageLanguage(language);
  }, []);

  const changeLangauge = lang => {
    setPageLanguage(lang);
    i18n.changeLanguage(lang);
    setOpenLanguageSelection(false);
  };

  useEffect(() => {
    if (!user) return;
    setUserProfile(user.profile.name);
  }, [user]);

  const logoutUser = () => {
    userManager.removeUser();
  };

  return (
    <div className="settings__content">
      <div className="settings__item">
        <label>{t('language')}</label>
        <div
          className="settings__select"
          onClick={() => setOpenLanguageSelection(!openLanguageSelection)}
        >
          <div className="settings__select-left">
            <svg>
              <use xlinkHref={`${icons}#icon-globe`} />
            </svg>
            <div className="settings__select-text">
              {
                supportedLanguages.find(lang => lang.val === pageLanguage)
                  ?.label
              }
            </div>
          </div>
          <div className={`settings__select-right`}>
            <svg className="settings__select-arrow">
              <use xlinkHref={`${icons}#icon-arrow-right`} />
            </svg>
          </div>
        </div>
        <div
          className={`settings__languages ${
            openLanguageSelection ? 'settings__languages--open' : ''
          }`}
        >
          {supportedLanguages
            .filter(lang => lang.val !== pageLanguage)
            .map(lang => {
              return (
                <div
                  className={'settings__languages-option'}
                  key={lang.val}
                  onClick={() => {
                    changeLangauge(lang.val);
                  }}
                >
                  {lang.label}
                </div>
              );
            })}
        </div>
      </div>

      <div className="settings__item">
        <label>{userProfile || 'USER'}</label>
        <div className="settings__signout">
          <Button
            text={t('signout')}
            action={() => logoutUser()}
            type="primary"
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ oidc }) => ({ user: oidc.user });

export default connect(mapStateToProps)(User);
